var w = Object.defineProperty, E = Object.defineProperties;
var T = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var S = Object.prototype.hasOwnProperty, A = Object.prototype.propertyIsEnumerable;
var g = (s, t, e) => t in s ? w(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e, d = (s, t) => {
  for (var e in t || (t = {}))
    S.call(t, e) && g(s, e, t[e]);
  if (m)
    for (var e of m(t))
      A.call(t, e) && g(s, e, t[e]);
  return s;
}, f = (s, t) => E(s, T(t));
var n = (s, t, e) => g(s, typeof t != "symbol" ? t + "" : t, e);
var c = (s, t, e) => new Promise((i, r) => {
  var o = (u) => {
    try {
      l(e.next(u));
    } catch (y) {
      r(y);
    }
  }, a = (u) => {
    try {
      l(e.throw(u));
    } catch (y) {
      r(y);
    }
  }, l = (u) => u.done ? i(u.value) : Promise.resolve(u.value).then(o, a);
  l((e = e.apply(s, t)).next());
});
import { r as O, A as C } from "./analytics-client-Cj8q1Ezv.js";
import { i as X, p as tt } from "./analytics-client-Cj8q1Ezv.js";
import p from "posthog-js";
function _(s, t) {
  return `mx.${s}.${t}`;
}
class P {
  constructor(t) {
    this.config = t, this.name = "posthog", this.isGroupGated = !0, this.initialised = !1;
  }
  init() {
    this.initialised || (p.init(this.config.apiKey, { api_host: this.config.host, defaults: "2026-01-30" }), this.initialised = !0);
  }
  identify(t, e) {
    p.identify(t, e);
  }
  setCommonProps() {
  }
  track(t) {
    p.capture(_(t.commonProps.mx_app, t.name), d(d({}, t.commonProps), t.props));
  }
  shutdown() {
    p.reset();
  }
}
const I = "https://us.i.posthog.com", U = "phc_9yc5ytpVb7nmZTvJUBSqbMjvNQnge59n4l7VLddsxFA";
class b {
  constructor(t, e) {
    n(this, "application");
    n(this, "district_id");
    n(this, "timestamp");
    n(this, "locations", {});
    n(this, "duration", 0);
    this.timestamp = (/* @__PURE__ */ new Date()).toISOString(), this.district_id = t, this.application = e;
  }
  addLocation(t) {
    var r, o;
    const e = `${t.product}:${t.location}`;
    this.duration += t.duration;
    const i = (o = (r = this.locations[e]) == null ? void 0 : r.duration) != null ? o : 0;
    this.locations[e] = {
      duration: i + t.duration
    };
  }
}
class $ {
  constructor(t) {
    n(this, "getAuthCallback");
    n(this, "syncOptions");
    this.syncOptions = t, this.getAuthCallback = t.getAuthCallback, this.log("TeacherTotterSync initialized with options: ", t);
  }
  sync(t, e, i) {
    return c(this, null, function* () {
      return Object.keys(t.locations).length === 0 ? !1 : (this.log("Syncing session with locations: ", t.locations), yield new v(t, this.syncOptions.syncUrl, this.getAuthCallback, this.syncOptions.debugMode, e, i).sync());
    });
  }
  sendEvent(t) {
    return c(this, null, function* () {
      return this.log("Sending event: ", t), yield new v(
        new b(),
        this.syncOptions.syncUrl,
        this.getAuthCallback,
        this.syncOptions.debugMode
      ).sendEvent(t);
    });
  }
  log(...t) {
    var e;
    (e = this.syncOptions) != null && e.debugMode && console.debug(...t);
  }
}
class v {
  constructor(t, e, i, r, o, a) {
    n(this, "headers", {
      "content-type": "application/json"
    });
    n(this, "getAuthCallback");
    n(this, "debugMode");
    n(this, "onSuccess");
    n(this, "onFailure");
    n(this, "retryCount", 0);
    n(this, "session");
    n(this, "syncUrl");
    this.session = t, this.syncUrl = e, this.debugMode = r, this.onSuccess = o, this.onFailure = a, i && (this.getAuthCallback = i);
  }
  applyAuth() {
    return c(this, null, function* () {
      if (this.getAuthCallback) {
        const t = yield this.getAuthCallback();
        t && (this.headers.authorization = t);
      }
    });
  }
  sync() {
    return c(this, null, function* () {
      var e;
      if (Object.keys(this.session.locations).length === 0) return;
      yield this.applyAuth(), h("teacher-tot-sync-started");
      const t = `${this.syncUrl}/session_event`;
      this.log("Syncing session with URL: ", t);
      try {
        const i = yield fetch(t, {
          method: "POST",
          body: JSON.stringify(this.session),
          headers: this.headers,
          keepalive: !0
        });
        return i.ok ? (this.log("Sync successful"), (e = this.onSuccess) == null || e.call(this), h("teacher-tot-sync-complete"), !0) : (this.log("Sync failed with status: ", i.status), this.retry(), !1);
      } catch (i) {
        console.error(i), this.retry();
      }
    });
  }
  sendEvent(t) {
    return c(this, null, function* () {
      yield this.applyAuth();
      const e = `${this.syncUrl}/teacher_event`;
      this.log("Sending event to URL: ", e);
      try {
        const i = yield fetch(e, {
          method: "POST",
          body: JSON.stringify(t),
          headers: this.headers,
          keepalive: !0
        });
        return i.ok ? (this.log("Event sent successfully"), h("teacher-tot-event-sent"), !0) : (this.log("Event sending failed with status: ", i.status), this.retrySendEvent(t), !1);
      } catch (i) {
        return console.error(i), this.retrySendEvent(t), !1;
      }
    });
  }
  retry() {
    var t;
    this.retryCount < 3 ? (this.log("Retrying sync..."), this.retryCount += 1, setTimeout(() => {
      this.sync();
    }, 5e3)) : (t = this.onFailure) == null || t.call(this);
  }
  retrySendEvent(t) {
    this.retryCount < 3 && (this.log("Retrying event send..."), this.retryCount += 1, setTimeout(() => {
      this.sendEvent(t);
    }, 5e3));
  }
  log(...t) {
    this.debugMode && console.debug(...t);
  }
}
class j {
  constructor({ idleTimeout: t = 6e4, incrementCallback: e, tickFrequency: i = 1e3 }) {
    n(this, "timer");
    n(this, "idleTimeout");
    n(this, "incrementCallback");
    n(this, "lastUserActivity");
    n(this, "tickFrequency");
    this.incrementCallback = e, this.tickFrequency = i, this.idleTimeout = t, this.lastUserActivity = (/* @__PURE__ */ new Date()).getTime(), this.tick();
  }
  tick() {
    if (this.shouldPause) {
      h("teacher-totter-pause"), this.timer = void 0;
      return;
    }
    this.timer = setTimeout(() => {
      h("teacher-totter-tick"), this.increment(), this.tick();
    }, this.tickFrequency);
  }
  increment() {
    h("teacher-totter-increment"), this.incrementCallback();
  }
  get shouldPause() {
    return (/* @__PURE__ */ new Date()).getTime() - this.lastUserActivity > this.idleTimeout;
  }
  userActive() {
    this.lastUserActivity = (/* @__PURE__ */ new Date()).getTime(), this.resume();
  }
  removeTimer() {
    clearTimeout(this.timer), this.timer = void 0;
  }
  resume() {
    this.timer || (h("teacher-totter-resume"), this.tick());
  }
}
class N {
  constructor(t, e) {
    n(this, "districtId");
    n(this, "browser");
    n(this, "application");
    this.browser = navigator.userAgent, this.districtId = t, this.application = e;
  }
  buildEvent(t) {
    var e;
    return {
      districtId: this.districtId,
      application: this.application,
      browser: this.browser,
      eventName: t.eventName,
      product: t.product,
      additionalData: (e = t.additionalData) != null ? e : {},
      timestamp: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
}
const k = "teacher-totter:pending-session";
class D {
  constructor(t, e, i) {
    n(this, "key");
    n(this, "district_id");
    n(this, "application");
    n(this, "state");
    this.key = t, this.district_id = e, this.application = i, this.state = this.loadOrInit(), this.recoverSyncing(), this.finalizeCurrentEvent();
  }
  get currentEvent() {
    return this.state.currentEvent;
  }
  get pending() {
    return this.state.pending;
  }
  get hasPendingData() {
    return Object.keys(this.state.pending).length > 0;
  }
  trackLocation(t, e) {
    this.state.currentEvent = { location: t, product: e, duration: 0 }, this.persist();
  }
  incrementTimeAtLocation() {
    this.state.currentEvent && (this.state.currentEvent.duration += 1, this.persist());
  }
  finalizeCurrentEvent() {
    var a, l;
    if (!this.state.currentEvent) return;
    const { location: t, product: e, duration: i } = this.state.currentEvent, r = `${e}:${t}`, o = (l = (a = this.state.pending[r]) == null ? void 0 : a.duration) != null ? l : 0;
    this.state.pending[r] = { duration: o + i }, this.state.currentEvent = void 0, this.persist();
  }
  startSync() {
    if (Object.keys(this.state.pending).length === 0) return null;
    const t = new b(this.district_id, this.application);
    return t.locations = d({}, this.state.pending), t.duration = Object.values(this.state.pending).reduce((e, { duration: i }) => e + i, 0), this.state.syncing = d({}, this.state.pending), this.state.pending = {}, this.persist(), t;
  }
  confirmSync() {
    this.state.syncing = {}, this.persist();
  }
  failSync() {
    var t, e;
    for (const [i, { duration: r }] of Object.entries(this.state.syncing)) {
      const o = (e = (t = this.state.pending[i]) == null ? void 0 : t.duration) != null ? e : 0;
      this.state.pending[i] = { duration: o + r };
    }
    this.state.syncing = {}, this.persist();
  }
  recoverSyncing() {
    Object.keys(this.state.syncing).length !== 0 && this.failSync();
  }
  loadOrInit() {
    try {
      const t = localStorage.getItem(this.key);
      if (t) return JSON.parse(t);
    } catch (t) {
    }
    return this.emptyState();
  }
  emptyState() {
    return {
      pending: {},
      syncing: {}
    };
  }
  persist() {
    try {
      this.isEmpty() ? localStorage.removeItem(this.key) : localStorage.setItem(this.key, JSON.stringify(this.state));
    } catch (t) {
    }
  }
  isEmpty() {
    return !this.state.currentEvent && Object.keys(this.state.pending).length === 0 && Object.keys(this.state.syncing).length === 0;
  }
}
const F = [
  "keypress",
  "keydown",
  "click",
  "contextmenu",
  "dblclick",
  "mousemove",
  "scroll",
  "touchmove",
  "touchstart"
];
function L(s, t) {
  return s || (t ? `${k}:${t}` : k);
}
class M {
  constructor({ districtId: t, application: e, options: i }) {
    n(this, "application");
    n(this, "district_id");
    n(this, "eventBuilder");
    n(this, "syncer");
    n(this, "ticker");
    n(this, "buffer");
    n(this, "options");
    var o;
    this.district_id = t, this.application = e;
    const r = L(i.storageKey, e == null ? void 0 : e.name);
    this.buffer = new D(r, t, e), this.syncer = new $(f(d({}, i.syncOptions), {
      debugMode: i.debugMode
    })), this.eventBuilder = new N(t, this.application), this.options = i, this.log("TeacherTotter initialized with options: ", i), this.buffer.hasPendingData && (this.log("Found pending data in storage, syncing immediately"), setTimeout(() => this.sync(), 0)), window.addEventListener("blur", () => {
      var a;
      (a = this.ticker) == null || a.removeTimer();
    }), F.forEach((a) => {
      window.addEventListener(a, () => this.refreshTicker());
    }), document.addEventListener("visibilitychange", () => c(this, null, function* () {
      document.visibilityState === "hidden" && (yield this.sync());
    })), setInterval(() => this.sync(), (o = i.syncFrequency) != null ? o : 6e4), i.debugMode && (window.tot = this);
  }
  refreshTicker() {
    this.ticker && this.ticker.userActive();
  }
  trackSession(t, e) {
    return c(this, null, function* () {
      this.untrackSession(), this.buffer.trackLocation(t, e), this.ticker = new j({
        idleTimeout: this.options.idleTimeout,
        incrementCallback: () => {
          this.buffer.incrementTimeAtLocation();
        }
      }), this.log(`Tracking session: ${t} for product: ${e}`), h("teacher-totter-track-session", {
        detail: {
          name: t
        }
      });
    });
  }
  /*
  /** Send an event to the backend
   *
   * @param eventName - The name of the event
   * @param product - The product associated with the event
  * @param additionalData - Any additional data to send with the event.
   */
  sendEvent(t, e, i) {
    return c(this, null, function* () {
      const r = this.eventBuilder.buildEvent({
        eventName: t,
        product: e,
        additionalData: i
      });
      return this.log("Sending event: ", r), this.syncer.sendEvent(r);
    });
  }
  untrackSession() {
    var t;
    this.ticker && (this.log(`Untracking session: for product: ${(t = this.buffer.currentEvent) == null ? void 0 : t.product} `, this.buffer.currentEvent), this.buffer.finalizeCurrentEvent(), this.ticker.removeTimer(), this.ticker = void 0);
  }
  sync() {
    return c(this, null, function* () {
      this.log("Syncing data...");
      const t = this.buffer.startSync();
      t && (yield this.syncer.sync(
        t,
        () => this.buffer.confirmSync(),
        () => this.buffer.failSync()
      ));
    });
  }
  log(...t) {
    var e;
    (e = this.options) != null && e.debugMode && console.debug(...t);
  }
}
function h(s, t) {
  const e = new CustomEvent(s, t);
  document.dispatchEvent(e);
}
class J {
  constructor(t) {
    this.config = t, this.name = "teacher-totter", this.isGroupGated = !1, this.instance = null, this.application = null;
  }
  init() {
    var t, e;
    this.instance || (this.application = { name: this.config.app, metadata: {} }, this.instance = new M({
      application: this.application,
      options: {
        syncOptions: {
          syncUrl: this.config.syncUrl,
          getAuthCallback: () => c(this, null, function* () {
            var i, r, o;
            return (o = yield (r = (i = this.config).getAuthToken) == null ? void 0 : r.call(i)) != null ? o : void 0;
          })
        }
      }
    }), (e = (t = this.config).getAuthToken) == null || e.call(t));
  }
  identify() {
  }
  setCommonProps(t) {
    this.application && (this.application.metadata = d({}, t));
  }
  track(t) {
    return c(this, null, function* () {
      var e;
      yield (e = this.instance) == null ? void 0 : e.sendEvent(t.name, this.config.product, t.props);
    });
  }
  trackSession(t) {
    var e;
    (e = this.instance) == null || e.trackSession(t, this.config.product);
  }
  shutdown() {
    this.instance = null, this.application = null;
  }
}
function q(s) {
  var r, o;
  const t = [], { posthog: e, teacherTotter: i } = s.providers;
  return e != null && e.enabled && t.push(
    new P({
      apiKey: (r = e.apiKey) != null ? r : U,
      host: (o = e.host) != null ? o : I
    })
  ), i != null && i.enabled && t.push(
    new J({
      app: s.app,
      syncUrl: i.syncUrl,
      product: i.product,
      getAuthToken: i.getAuthToken
    })
  ), t;
}
function V(s) {
  const t = O(s);
  return new C(t, q(t));
}
const z = /^[a-z0-9]+(\.[a-z0-9-]+)+$/;
function x(s) {
  for (const t of Object.keys(s))
    if (!z.test(t))
      throw new Error(`[analytics] Invalid event name "${t}". Expected domain.action, e.g. "assignment.confirmed".`);
  return s;
}
const W = x({
  "page.view": { group: "core", props: {} },
  "page.time-on-page": { group: "core", props: {} },
  "section.error": { group: "core", props: {} }
}), G = "/create-jwt-token";
function H(s, t) {
  return c(this, null, function* () {
    const e = yield fetch(`${s}${G}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ authToken: t })
    });
    if (!e.ok) return;
    const i = yield e.json();
    if (!(!i.success || !i.token))
      return i.token;
  });
}
function Q({
  identityGatewayUrl: s,
  getAppAuthToken: t
}) {
  let e, i = null;
  return () => c(null, null, function* () {
    const r = t();
    if (!(!r || !s))
      return e || (i || (i = H(s, r).then((o) => (o || console.warn("[analytics] Identity JWT response did not include a token."), e = o, i = null, e)).catch(() => {
        console.warn("[analytics] Identity JWT request failed."), i = null;
      })), i);
  });
}
export {
  W as SHARED_EVENTS,
  V as createAnalytics,
  Q as createIdentityJwtTokenGetter,
  x as defineEvents,
  X as isFeatureEnabled,
  tt as parseEnabledGroups
};



//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/mx-teacher-analytics/dist/analytics.js
// module id = 2HaB
// module chunks = 0